import { Link } from 'react-router-dom'
import Header from '../components/Header'
import '../styles/Landing.css'

const YOUTUBE_VIDEOS = [
  { id: 'k2W2fScq2Q8', title: 'היא חזרה בתשובה (מתי כספי)' },
  { id: 'EaU6_ybSbNU', title: 'עוד יום (מתי כספי)' },
  { id: '-Luwo-hPYSw', title: 'שיר ללא שם (שלמה חנוך)' },
  { id: 'crFvADlmojQ', title: 'ימים לבנים' },
  { id: 'mLA1EJGMbAQ', title: 'יש בי עוד כח (עידן רייכל)' },
  { id: 'FUXsqP22Sls', title: 'האיש מן הבקעה' },
];

export default function Landing() {
  return (
    <div className="landing-page" dir="rtl">
      <Header />

      {/* Hero */}
      <section className="landing-hero">
        <div className="landing-hero-content">
          <h1 className="landing-hero-title">
            למדו גיטרה
            <br />
            <span className="landing-hero-highlight">עם חגי רחביה</span>
          </h1>
          <p className="landing-hero-subtitle">
            קורס אינטראקטיבי ללימוד ליווי שירים בסגנון פינגרסטייל.
            <br />
            צפו, תרגלו, הקליטו — וקבלו משוב אישי בווידאו.
          </p>
          <div className="landing-hero-cta">
            <Link to="/courses/matticaspi" className="btn btn-primary btn-lg">
              התחילו ללמוד
            </Link>
            <a href="#intro-video" className="btn btn-secondary btn-lg">
              צפו בסרטון
            </a>
          </div>
        </div>
      </section>

      {/* Intro Video Placeholder */}
      <section className="landing-section" id="intro-video">
        <div className="landing-container">
          <h2 className="landing-section-title">היכרות עם הקורס</h2>
          <div className="landing-video-placeholder">
            <div className="landing-video-placeholder-inner">
              <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="var(--color-accent)" strokeWidth="1.5">
                <circle cx="12" cy="12" r="10" />
                <polygon points="10 8 16 12 10 16 10 8" fill="var(--color-accent)" />
              </svg>
              <p>הסרטון בקרוב...</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="landing-section landing-section-alt">
        <div className="landing-container">
          <h2 className="landing-section-title">איך זה עובד?</h2>
          <div className="landing-steps">
            <div className="landing-step-card">
              <div className="landing-step-number">1</div>
              <h3 className="landing-step-title">צפו בשיעור וידאו</h3>
              <p className="landing-step-desc">
                חגי מדגים את הליווי שלב אחרי שלב, עם טאבים מוטמעים בתוך הווידאו.
                ניתן להאט את מהירות הנגינה לתרגול נוח.
              </p>
            </div>
            <div className="landing-step-card">
              <div className="landing-step-number">2</div>
              <h3 className="landing-step-title">תרגלו עם חומרי עזר</h3>
              <p className="landing-step-desc">
                לכל שיעור יש דף אקורדים (PDF) ורצועת מנגינה להשמעה ברקע.
                תרגלו את הליווי בזמן שהמנגינה מתנגנת.
              </p>
            </div>
            <div className="landing-step-card">
              <div className="landing-step-number">3</div>
              <h3 className="landing-step-title">שלחו הקלטה וקבלו משוב אישי</h3>
              <p className="landing-step-desc">
                הקליטו את עצמכם בווידאו ושלחו לחגי.
                תקבלו בחזרה משוב אישי מוקלט בווידאו עם הערות מדויקות.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* About the Course */}
      <section className="landing-section">
        <div className="landing-container">
          <h2 className="landing-section-title">קורס ליווי שירי מתי כספי</h2>
          <div className="landing-course-card">
            <div className="landing-course-info">
              <p className="landing-course-desc">
                קורס ייחודי ללימוד ליווי גיטרה על שירים של מתי כספי.
                לכל שיר יש שיעור וידאו מפורט, דף אקורדים, ורצועת מנגינה לתרגול.
                הקליטו את הביצוע שלכם וקבלו משוב אישי מחגי רחביה.
              </p>
              <div className="landing-course-stats">
                <span>7 שיעורים</span>
                <span className="landing-course-stats-dot" />
                <span>שירי מתי כספי</span>
                <span className="landing-course-stats-dot" />
                <span>ליווי גיטרה</span>
              </div>
              <Link to="/courses/matticaspi" className="btn btn-primary">
                לקורס המלא
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* YouTube Carousel */}
      <section className="landing-section landing-section-alt">
        <div className="landing-container">
          <h2 className="landing-section-title">מתוך ערוץ היוטיוב של חגי</h2>
          <div className="landing-yt-carousel">
            {YOUTUBE_VIDEOS.map((video) => (
              <div key={video.id} className="landing-yt-item">
                <iframe
                  src={`https://www.youtube.com/embed/${video.id}`}
                  title={video.title}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  loading="lazy"
                />
                <p className="landing-yt-title">{video.title}</p>
              </div>
            ))}
          </div>
          <div style={{ textAlign: 'center', marginTop: 'var(--space-lg)' }}>
            <a
              href="https://www.youtube.com/@Hagai-Rehavia-fingerstyle/videos"
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn-ghost"
            >
              לערוץ היוטיוב המלא &larr;
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="landing-footer">
        <div className="landing-container" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>&copy; 2026 Fingerstyle Studio &middot; חגי רחביה</span>
          <a
            href="https://www.youtube.com/@Hagai-Rehavia-fingerstyle"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: 'var(--color-accent)' }}
          >
            YouTube
          </a>
        </div>
      </footer>
    </div>
  )
}
